import type { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";
import { Brands } from "@App/Pages/Common/Brands";

/**
 * The funnel for the certificate service.
 *
 * @constructor
 */
export const Certificate: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("hu-au-tuev");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Jetzt online TÜV buchen"}
            step={0}
            maxSteps={1}
            onSubmit={() => navigateWithQuery(`ort`)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Jetzt online TÜV buchen"}
            subheadline={"Wo willst du deinen TÜV durchführen lassen?"}
            description={" "}
            step={1}
            maxSteps={1}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
    </Routes>
  );
};
